/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S11_Cloudflare_BodyInputs */

const tr_mesafeli_s11_cloudflare_body = /** @type {(inputs: Mesafeli_S11_Cloudflare_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workers runtime, CDN, WAF, Secrets Store.`)
};

const en_mesafeli_s11_cloudflare_body = /** @type {(inputs: Mesafeli_S11_Cloudflare_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workers runtime, CDN, WAF, Secrets Store.`)
};

const de_mesafeli_s11_cloudflare_body = /** @type {(inputs: Mesafeli_S11_Cloudflare_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workers-Runtime, CDN, WAF, Secrets Store.`)
};

const ru_mesafeli_s11_cloudflare_body = /** @type {(inputs: Mesafeli_S11_Cloudflare_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workers runtime, CDN, WAF, Secrets Store.`)
};

/**
* | output |
* | --- |
* | "Workers runtime, CDN, WAF, Secrets Store." |
*
* @param {Mesafeli_S11_Cloudflare_BodyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s11_cloudflare_body = /** @type {((inputs?: Mesafeli_S11_Cloudflare_BodyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S11_Cloudflare_BodyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s11_cloudflare_body(inputs)
	if (locale === "de") return de_mesafeli_s11_cloudflare_body(inputs)
	if (locale === "ru") return ru_mesafeli_s11_cloudflare_body(inputs)
	return tr_mesafeli_s11_cloudflare_body(inputs)
});